import { ERROR_LOG_SCREENSHOT_IGNORE_ATTR } from 'data/error-log-constants';

export function shouldIgnoreScreenshotElement(element: Element): boolean {
  if (element.closest('.swal2-container')) {
    return true;
  }
  return element.closest(`[${ERROR_LOG_SCREENSHOT_IGNORE_ATTR}]`) !== null;
}
